import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import language from '../../../../assets/languages/language';
import CommonDetailStatus from '../../../Common/CommonDetailStatus';
import CommonFilter from '../../../Common/CommonFilter';
import FrmSubscriptionCheck from '../../../RestAPI/FrmSubscription';
import PartnerFRMSubscriptionCheck from '../../../RestAPI/PartnerSubscription/FrmSubscription';
import FD from '../../../RestAPI/fetchData';
import App_data from '../../../config/App_data';
// import ScrollUpButton from "react-scroll-up-button";

/* eslint-disable*/
class ViewFrmAllQues extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allQuestion: [],
      selectedChapter: '',
      selectedReading: '',
      selectedQuestion: '',
      selectedAnswered: '',
      selectedAttempts: '',
      selectedAvgScore: '',
      selectedPassingScore: '',
      selectedLowerLimit: '',
      selectedUpperLimit: '',
      readings: [],
      chapters: [],
      totalQuestions: '',
      currentPage: 1,
      pageLimit: 20,
      pageNeighbours: 1,
      questionLowerLimit: 0,
      questionUpperLimit: 20,
      loader: true,
      url: new URL(window.location.href),
      subscriptionstatus: '',
      selectedmenu: 'frm',
      selectedmen: '',
      selectedLevel: 'frm1',
      level: '1',
    };
  }

  setSelectedChapter = e => {
    const chapterId = e.target.value;
    this.setState({
      selectedChapter: e.target.value,
      selectedQuestion: '',
    });
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      chapter: chapterId,
      reading: this.state.selectedReading,
    };
    FD.callAPI(App_data.backend_api + '/frm_question_bank/getReadings', data).then(resp => {
      if (resp.success) {
        this.setState({ ValidToken: true });
        this.setState({ readings: resp.readings }, () => {});
      } else {
        this.setState({ ValidToken: false });
      }
    });
  };

  setSelectedReading = e => {
    this.setState({ selectedReading: e.target.value, selectedQuestion: '' });
  };

  setSelectedQuestion = e => {
    this.setState({
      selectedQuestion: e.target.value,
      selectedChapter: '',
      selectedReading: '',
      selectedAnswered: '',
      selctedAttempts: '',
      selectedAvgScore: '',
      selectedPassingScore: '',
    });
  };

  setSelectedAnswered = e => {
    this.setState({ selectedAnswered: e.target.value });
  };

  setSelectedNoOfAttempts = e => {
    this.setState({ selectedAttempts: e.target.value });
  };

  setSelectedPagination = async (page, data) => {
    this.setState({
      totalPages: data.totalPages,
      pageLimit: data.pageLimit,
      totalQuestions: data.totalQuestions,
      currentPage: page,
      loader: true,
    });
    var pageMinusOne = page - 1;
    var questionLowerLimit = pageMinusOne * 20;
    var questionUpperLimit = pageMinusOne * 20 + 20;
    this.setState(
      {
        questionLowerLimit: questionLowerLimit,
        questionUpperLimit: questionUpperLimit,
      },
      async () => {
        var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
        this.setState({
          idname: storage_session['idname'],
          token: storage_session['token'],
        });
        var data = {
          token: storage_session['token'],
          idname: storage_session['idname'],
          chapter: this.state.selectedChapter,
          reading: this.state.selectedReading,
          question: this.state.selectedQuestion,
          selectedAnswered: this.state.selectedAnswered,
          selectedAttempts: this.state.selectedAttempts,
          selectedAvgScore: this.state.selectedAvgScore,
          selectedLowerLimit: this.state.selectedLowerLimit,
          selectedUpperLimit: this.state.selectedUpperLimit,
          selectedPassingScore: this.state.selectedPassingScore,
          questionLowerLimit: this.state.questionLowerLimit,
          questionUpperLimit: this.state.questionUpperLimit,
          subscriptionstatus: this.state.subscriptionstatus,
          level: this.state.level,
        };
        await FD.callAPI(
          App_data.backend_api + '/frm_question_bank/getAllQuestionStatus',
          data,
        ).then(resp => {
          if (resp.success) {
            window.scroll(0, 0);

            this.setState({ ValidToken: true });

            this.setState(
              {
                allQuestion: resp.allQuestions,
                totalQuestions: resp.totalQuestions,
                loader: false,
                selectedLevel: this.state.selectedLevel,
              },
              () => {
                browserHistory.push(
                  `/frm/viewallquestions/?sQ=${this.state.selectedQuestion}&c=${
                    this.state.selectedChapter
                  }&s=${this.state.selectedReading}&sAns=${this.state.selectedAnswered}&sAtt=${
                    this.state.selectedAttempts
                  }&sAvgS=${this.state.selectedAvgScore}&sLl=${this.state.selectedLowerLimit}&sUl=${
                    this.state.selectedUpperLimit
                  }&sPs=${this.state.selectedUpperLimit}&sQll=${
                    this.state.questionLowerLimit
                  }&sQul=${this.state.questionUpperLimit}`,
                );
              },
            );
          } else {
            this.setState({ ValidToken: false });
          }
        });

        await FD.callAPI(App_data.backend_api + '/frm_question_bank/getChaptersFrm1', data).then(
          resp => {
            if (resp.success) {
              this.setState({ chapters: resp.chapters }, () => {});
            } else {
              this.setState({ ValidToken: false });
            }
          },
        );
      },
    );
  };

  setSelectedChangeAvgScores = e => {
    if (e.target.value === '0') {
      this.setState({
        selectedAvgScore: e.target.value,
        selectedLowerLimit: '0',
        selectedUpperLimit: '25',
      });
    }

    if (e.target.value === '1') {
      this.setState({
        selectedAvgScore: e.target.value,
        selectedLowerLimit: '25',
        selectedUpperLimit: '50',
      });
    } else if (e.target.value === '2') {
      this.setState({
        selectedAvgScore: e.target.value,
        selectedLowerLimit: '50',
        selectedUpperLimit: '70',
      });
    } else if (e.target.value === '3') {
      this.setState({
        selectedAvgScore: e.target.value,
        selectedLowerLimit: '70',
        selectedUpperLimit: '100',
      });
    }
  };

  setSelectedChangePass = e => {
    this.setState({ selectedPassingScore: e.target.value });
  };

  resetAllQuestion = () => {
    this.setState(
      {
        selectedChapter: '',
        selectedReading: '',
        selectedQuestion: '',
        selectedAnswered: '',
        selectedAttempts: '',
        selectedAvgScore: '',
        selectedPassingScore: '',
        selectedLowerLimit: '',
        selectedUpperLimit: '',
        questionLowerLimit: '0',
        questionUpperLimit: '20',
        readings: [],
        loader: true,
      },
      async () => {
        var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
        this.setState({
          idname: storage_session['idname'],
          token: storage_session['token'],
        });
        var data = {
          token: storage_session['token'],
          idname: storage_session['idname'],
          chapter: this.state.selectedChapter,
          reading: this.state.selectedReading,
          question: this.state.selectedQuestion,
          selectedAnswered: this.state.selectedAnswered,
          selectedAttempts: this.state.selectedAttempts,
          selectedAvgScore: this.state.selectedAvgScore,
          selectedLowerLimit: this.state.selectedLowerLimit,
          selectedUpperLimit: this.state.selectedUpperLimit,
          selectedPassingScore: this.state.selectedPassingScore,
          questionLowerLimit: this.state.questionLowerLimit,
          questionUpperLimit: this.state.questionUpperLimit,
          subscriptionstatus: this.state.subscriptionstatus,
          level: this.state.level,
        };
        await FD.callAPI(
          App_data.backend_api + '/frm_question_bank/getAllQuestionStatus',
          data,
        ).then(resp => {
          if (resp.success) {
            // console.log(resp)
            this.setState({ ValidToken: true });
            //   console.log(typeof resp.allQuestions)
            this.setState(
              {
                allQuestion: resp.allQuestions,
                totalQuestions: resp.totalQuestions,
                loader: false,
                selectedLevel: this.state.selectedLevel,
              },
              () => {
                browserHistory.push(
                  `/frm/viewallquestions/?sQ=${this.state.selectedQuestion}&c=${
                    this.state.selectedChapter
                  }&s=${this.state.selectedReading}&sAns=${this.state.selectedAnswered}&sAtt=${
                    this.state.selectedAttempts
                  }&sAvgS=${this.state.selectedAvgScore}&sLl=${this.state.selectedLowerLimit}&sUl=${
                    this.state.selectedUpperLimit
                  }&sPs=${this.state.selectedUpperLimit}&sQll=${
                    this.state.questionLowerLimit
                  }&sQul=${this.state.questionUpperLimit}&searchBy=questionID`,
                );
              },
            );
          } else {
            this.setState({ ValidToken: false });
          }
        });

        await FD.callAPI(App_data.backend_api + '/frm_question_bank/getChaptersFrm1', data).then(
          resp => {
            if (resp.success) {
              this.setState({ chapters: resp.chapters }, () => {});
            } else {
              this.setState({ ValidToken: false });
            }
          },
        );
      },
    );
  };

  resetAllChapter = () => {
    this.setState(
      {
        selectedChapter: '',
        selectedReading: '',
        selectedQuestion: '',
        selectedAnswered: '',
        selectedAttempts: '',
        selectedAvgScore: '',
        selectedPassingScore: '',
        selectedLowerLimit: '',
        selectedUpperLimit: '',
        questionLowerLimit: '0',
        questionUpperLimit: '20',
        readings: [],
        loader: true,
      },
      async () => {
        var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
        this.setState({ idname: storage_session['idname'] });
        this.setState({ token: storage_session['token'] });
        var data = {
          token: storage_session['token'],
          idname: storage_session['idname'],
          chapter: this.state.selectedChapter,
          reading: this.state.selectedReading,
          question: this.state.selectedQuestion,
          selectedAnswered: this.state.selectedAnswered,
          selectedAttempts: this.state.selectedAttempts,
          selectedAvgScore: this.state.selectedAvgScore,
          selectedLowerLimit: this.state.selectedLowerLimit,
          selectedUpperLimit: this.state.selectedUpperLimit,
          selectedPassingScore: this.state.selectedPassingScore,
          questionLowerLimit: this.state.questionLowerLimit,
          questionUpperLimit: this.state.questionUpperLimit,
          subscriptionstatus: this.state.subscriptionstatus,
          level: this.state.level,
        };
        await FD.callAPI(
          App_data.backend_api + '/frm_question_bank/getAllQuestionStatus',
          data,
        ).then(resp => {
          if (resp.success) {
            this.setState({ ValidToken: true });
            this.setState(
              {
                allQuestion: resp.allQuestions,
                totalQuestions: resp.totalQuestions,
                loader: false,
                selectedLevel: this.state.selectedLevel,
              },
              () => {
                browserHistory.push(
                  `/frm/viewallquestions/?sQ=${this.state.selectedQuestion}&c=${
                    this.state.selectedChapter
                  }&s=${this.state.selectedReading}&sAns=${this.state.selectedAnswered}&sAtt=${
                    this.state.selectedAttempts
                  }&sAvgS=${this.state.selectedAvgScore}&sLl=${this.state.selectedLowerLimit}&sUl=${
                    this.state.selectedUpperLimit
                  }&sPs=${this.state.selectedUpperLimit}&sQll=${
                    this.state.questionLowerLimit
                  }&sQul=${this.state.questionUpperLimit}&searchBy=chapterID`,
                );
              },
            );
          } else {
            this.setState({ ValidToken: false });
          }
        });

        await FD.callAPI(App_data.backend_api + '/frm_question_bank/getChaptersFrm1', data).then(
          resp => {
            if (resp.success) {
              this.setState({ chapters: resp.chapters }, () => {});
            } else {
              this.setState({ ValidToken: false });
            }
          },
        );
      },
    );
  };

  async _filerQuestionsByChapter() {
    this.setState({ loader: true });
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      chapter: this.state.selectedChapter,
      reading: this.state.selectedReading,
      question: this.state.selectedQuestion,
      selectedAnswered: this.state.selectedAnswered,
      selectedAttempts: this.state.selectedAttempts,
      selectedAvgScore: this.state.selectedAvgScore,
      selectedLowerLimit: this.state.selectedLowerLimit,
      selectedUpperLimit: this.state.selectedUpperLimit,
      selectedPassingScore: this.state.selectedPassingScore,
      questionLowerLimit: this.state.questionLowerLimit,
      questionUpperLimit: this.state.questionUpperLimit,
      subscriptionstatus: this.state.subscriptionstatus,
      level: this.state.level,
    };
    await FD.callAPI(App_data.backend_api + '/frm_question_bank/getAllQuestionStatus', data).then(
      resp => {
        if (resp.success) {
          this.setState({ ValidToken: true });
          this.setState(
            {
              allQuestion: resp.allQuestions,
              totalQuestions: resp.totalQuestions,
              loader: false,
              selectedLevel: this.state.selectedLevel,
            },
            () => {
              browserHistory.push(
                `/frm/viewallquestions/?sQ=${this.state.selectedQuestion}&c=${
                  this.state.selectedChapter
                }&s=${this.state.selectedReading}&sAns=${this.state.selectedAnswered}&sAtt=${
                  this.state.selectedAttempts
                }&sAvgS=${this.state.selectedAvgScore}&sLl=${this.state.selectedLowerLimit}&sUl=${
                  this.state.selectedUpperLimit
                }&sPs=${this.state.selectedUpperLimit}&sQll=${this.state.questionLowerLimit}&sQul=${
                  this.state.questionUpperLimit
                }`,
              );
            },
          );
        } else {
          this.setState({ ValidToken: false });
        }
      },
    );
  }

  async componentDidMount() {
    {
      this.state.url.searchParams.get('c') !== null ||
      this.state.url.searchParams.get('sQ') !== null
        ? await this.setState({
            selectedQuestion: this.state.url.searchParams.get('sQ'),
            selectedChapter: this.state.url.searchParams.get('c'),
            selectedReading: this.state.url.searchParams.get('s'),
            selectedAnswered: this.state.url.searchParams.get('sAns'),
            selectedAttempts: this.state.url.searchParams.get('sAtt'),
            selectedAvgScore: this.state.url.searchParams.get('sAvgS'),
            selectedLowerLimit: this.state.url.searchParams.get('sLl'),
            selectedUpperLimit: this.state.url.searchParams.get('sUl'),
            selectedPassingScore: this.state.url.searchParams.get('sPs'),
            questionLowerLimit: this.state.url.searchParams.get('sQll'),
            questionUpperLimit: this.state.url.searchParams.get('sQul'),
          })
        : null;
    }
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var dataChapter = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      chapter: this.state.selectedChapter,
    };

    var user_data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
    };
    await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', user_data).then(async resp => {
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.setState({ subscriptionstatus: 'free' });
        } else {
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = '1';
                var isInArray_var = false;
                const examPlanData = resp_exam.examPlan[0];
                isInArray_var = await PartnerFRMSubscriptionCheck.checkFrm(selectedmen, exam_data, examPlanData);
                if (isInArray_var) {
                  this.setState({ subscriptionstatus: 'paid' });
                } else {
                  this.setState({ subscriptionstatus: 'free' });
                }
              } else {
                console.log('fail');
              }
            },
          );
        }
      } else {
        if (resp.profileInfo.exam_selected === '') {
          this.setState({ subscriptionstatus: 'free' });
        } else {
          var data_arr = JSON.parse(resp.profileInfo.exam_selected);
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = '1';
                var isInArray_var = false;
                isInArray_var = FrmSubscriptionCheck.checkFrm(selectedmen, exam_data);
                // console.log(isInArray_var)
                if (isInArray_var) {
                  // console.log('paid')
                  this.setState({ subscriptionstatus: 'paid' });
                } else {
                  // console.log('free')
                  this.setState({ subscriptionstatus: 'free' });
                }
              } else {
                console.log('fail');
              }
            },
          );
        }
      }
    });

    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      chapter: this.state.selectedChapter,
      reading: this.state.selectedReading,
      question: this.state.selectedQuestion,
      selectedAnswered: this.state.selectedAnswered,
      selectedAttempts: this.state.selectedAttempts,
      selectedAvgScore: this.state.selectedAvgScore,
      selectedLowerLimit: this.state.selectedLowerLimit,
      selectedUpperLimit: this.state.selectedUpperLimit,
      selectedUpperLimit: this.state.selectedPassingScore,
      questionLowerLimit: this.state.questionLowerLimit,
      questionUpperLimit: this.state.questionUpperLimit,
      subscriptionstatus: this.state.subscriptionstatus,
    };
    // console.log(data)
    await FD.callAPI(App_data.backend_api + '/frm_question_bank/getChaptersFrm1', data).then(
      async resp => {
        if (resp.success) {
          // console.log(resp.chapters)
          this.setState({ chapters: resp.chapters }, () => {
            browserHistory.push(
              `/frm/viewallquestions/?sQ=${this.state.selectedQuestion}&c=${
                this.state.selectedChapter
              }&s=${this.state.selectedReading}&sAns=${this.state.selectedAnswered}&sAtt=${
                this.state.selectedAttempts
              }&sAvgS=${this.state.selectedAvgScore}&sLl=${this.state.selectedLowerLimit}&sUl=${
                this.state.selectedUpperLimit
              }&sPs=${this.state.selectedUpperLimit}&sQll=${this.state.questionLowerLimit}&sQul=${
                this.state.questionUpperLimit
              }`,
            );
          });
        } else {
          this.setState({ ValidToken: false });
          // console.log(resp)
        }
      },
    );

    await FD.callAPI(App_data.backend_api + '/frm_question_bank/getAllQuestionStatus', data).then(
      async resp => {
        if (resp.success) {
          // console.log(resp)
          this.setState({ ValidToken: true });
          this.setState(
            {
              allQuestion: resp.allQuestions,
              totalQuestions: resp.totalQuestions,
              loader: false,
              selectedLevel: this.state.selectedLevel,
            },
            () => {},
          );
        } else {
          this.setState({ ValidToken: false });
          //   console.log(resp)
        }
      },
    );

    {
      this.state.chapter !== ''
        ? await FD.callAPI(
            App_data.backend_api + '/frm_question_bank/getReadings',
            dataChapter,
          ).then(async resp => {
            if (resp.success) {
              // console.log(resp)
              this.setState({ ValidToken: true });
              this.setState({ readings: resp.readings }, () => {
                // console.log(this.state.allQuestions)
              });
            } else {
              this.setState({ ValidToken: false });
              // console.log(resp)
            }
          })
        : null;
    }
  }

  render() {
    // console.log(this.state.subscriptionstatus)
    const {
      readings,
      allQuestion,
      chapters,
      selectedChapter,
      selectedReading,
      selectedQuestion,
      selectedAnswered,
      selectedAttempts,
      selectedAvgScore,
      selectedPassingScore,
      selectedLowerLimit,
      selectedUpperLimit,
      questionLowerLimit,
      questionUpperLimit,
      totalQuestions,
      pageLimit,
      pageNeighbours,
      currentPage,
      loader,
      subscriptionstatus,
      selectedmenu,
      level,
    } = this.state;
    return (
      <div className=''>
        <div className='row'>
          {' '}
          <div className='col-md-12 d-flex'>
            <img
              src={App_data.frontend_url + '/img/GARP_logo.png'}
              className='garpLogo'
              alt='full logo'
            />
          </div>
          <div className='col-md-12 top-heading-filter-toggle clrearfix'>
            <h1 className='section_head'>
              {' '}
              {language.LC().List_of_All_Questions_For} FRM Part -I{' '}
            </h1>{' '}
            <CommonFilter
              onChangeQuestion={this.setSelectedQuestion.bind(this)}
              onChangeChapter={this.setSelectedChapter.bind(this)}
              onChangeReading={this.setSelectedReading.bind(this)}
              onChangeAnswered={this.setSelectedAnswered.bind(this)}
              onChangeNoOfAttempts={this.setSelectedNoOfAttempts.bind(this)}
              onChangeAvgScore={this.setSelectedChangeAvgScores.bind(this)}
              onChangePass={this.setSelectedChangePass.bind(this)}
              onChangePagination={this.setSelectedPagination.bind(this)}
              readingData={readings}
              chapterData={chapters}
              filerSubmit={this._filerQuestionsByChapter.bind(this)}
              resetAllQuestion={this.resetAllQuestion.bind(this)}
              resetAllChapter={this.resetAllChapter.bind(this)}
              selectedChapter={selectedChapter}
              selectedAnswered={selectedAnswered}
              selectedReading={selectedReading}
              selectedQuestion={selectedQuestion}
              selectedAttempts={selectedAttempts}
              selectedAvgScore={selectedAvgScore}
              selectedPassingScore={selectedPassingScore}
              selectedLowerLimit={selectedLowerLimit}
              selectedUpperLimit={selectedUpperLimit}
              subscriptionstatus={subscriptionstatus}
              selectedmenu={selectedmenu}
            />
          </div>
        </div>
        <CommonDetailStatus
          onChangePagination={this.setSelectedPagination.bind(this)}
          allQuestionData={allQuestion}
          totalQuestions={totalQuestions}
          currentPage={currentPage}
          pageLimit={pageLimit}
          pageNeighbours={pageNeighbours}
          questionLowerLimit={questionLowerLimit}
          questionUpperLimit={questionUpperLimit}
          loader={loader}
          subscriptionstatus={subscriptionstatus}
          selectedmenu={selectedmenu}
          level={level}
        />
        {/* <ScrollUpButton
                  StopPosition={0}
                  ShowAtPosition={150}
                  EasingType="easeOutCubic"
                  AnimationDuration={500}
                  ContainerClassName="ScrollUpButton__Container"
                  TransitionClassName="ScrollUpButton__Toggled"
                  style={{}}
                  ToggledStyle={{}}
                /> */}
      </div>
    );
  }
}

export default ViewFrmAllQues;



// WEBPACK FOOTER //
// ./src/views/FRM/Frmdashboard/ViewFrmAllQues/ViewFrmAllQues.js